import React, { useState } from "react";
import AlertModal from "../../../components/alertModal";
import { formatMoney } from "../utils";
import SectionIcon from "./SectionIcon";

const formatDetailValue = (key, value, item) => {
  if (["valuation", "valor", "principal", "valor_poliza", "indemnizacion", "prima"].includes(key)) {
    return formatMoney(value, item.currency_type || item.moneda);
  }

  if (Array.isArray(value)) {
    return value.map((record) => (
      record && typeof record === "object" ? record.value || `${record.type}: ${record.id}` : record
    )).join(", ");
  }

  return value;
};

const previewDetailKeys = (sectionId, section, item) => {
  const keys = Object.keys(item).filter((key) => (
    item[key] &&
    !["currency_type", "estate_mapping_id", "herederos", "reviewIndex"].includes(key) &&
    (sectionId === "cuentas_inversion" || key !== section.nameKey)
  ));

  const firstKeys = sectionId === "cuentas_inversion"
    ? ["valuation", "valor", "custodio"]
    : ["valuation", "valor", "principal", "valor_poliza"];

  return firstKeys.filter((key) => keys.includes(key)).concat(
    keys.filter((key) => !firstKeys.includes(key) && key !== "numero_cuenta")
  );
};

const SectionListStep = ({ copy, sectionId, sections, items, onBack, onAdd, onEdit, onDelete, onNext }) => {
  const section = sections[sectionId];
  const [deleteIndex, setDeleteIndex] = useState(null);
  const closeDeleteModal = () => setDeleteIndex(null);
  const confirmDelete = () => {
    if (deleteIndex !== null) onDelete(deleteIndex);
    closeDeleteModal();
  };

  return (
    <section className="estate-mapping__content">
      <div className="estate-mapping__pillar-label">{section.pillar}</div>
      <div className="estate-mapping__section-heading">
        <SectionIcon section={section} />
        <div><h2>{section.title}</h2><p>{section.sub}</p></div>
      </div>
      <div className="estate-mapping__items">
        {items.map((item, index) => {
          const name = sectionId === "cuentas_inversion"
            ? item.numero_cuenta || copy.list.no_name
            : item[section.nameKey] || item.nombre || copy.list.no_name;
          return (
            <div className="estate-mapping__review-item estate-mapping__record-preview" key={`${name}-${index}`} onClick={() => onEdit(index)}>
              <div>
                <span className="estate-mapping__record-preview-title"><SectionIcon section={section} small /><strong>{name}</strong></span>
                <div className="estate-mapping__row-actions">
                  <button type="button" onClick={(event) => { event.stopPropagation(); onEdit(index); }} title={copy.buttons.edit}>{copy.buttons.edit}</button>
                  <button type="button" onClick={(event) => { event.stopPropagation(); setDeleteIndex(index); }} title={copy.buttons.delete}>{copy.buttons.delete}</button>
                </div>
              </div>
              <dl>
                {previewDetailKeys(sectionId, section, item).map((key) => (
                  <React.Fragment key={key}>
                    <dt>{key === "notes" ? copy.form.notes : (section.fields.find((field) => field.key === key) || {}).label || key}</dt>
                    <dd>{formatDetailValue(key, item[key], item)}</dd>
                  </React.Fragment>
                ))}
              </dl>
            </div>
          );
        })}
      </div>
      <button className="estate-mapping__add-button" onClick={onAdd} type="button">+ {section.addLabel}</button>
      {items.length === 0 && <div className="estate-mapping__empty-note">{copy.list.empty_section}</div>}
      <div className="estate-mapping__footer-actions">
        <button className="estate-mapping__button estate-mapping__button--secondary" onClick={onBack}>{copy.buttons.previous}</button>
        <div>
          <button className="estate-mapping__button estate-mapping__button--primary" onClick={onNext}>{copy.buttons.continue}</button>
        </div>
      </div>
      {deleteIndex !== null && (
        <AlertModal
          isShowed={deleteIndex !== null}
          title={copy.list.delete_confirmation_title}
          msg={copy.list.delete_confirmation_body}
          action={confirmDelete}
          textButton={copy.buttons.delete}
          textButtonAlertColor={true}
          cancelButton={true}
          cancelTextButton={copy.buttons.cancel}
          actionCancelButton={closeDeleteModal}
        />
      )}
    </section>
  );
};

export default SectionListStep;
